export enum Role {
  Admin = 'admin',
  EnterpriseAdmin = 'enterprise_admin',
  User = 'user',
  Vet = 'vet',
}
